import { IconMessageCircle } from '@tabler/icons-react';
import classes from './_gridLayout.module.css';

export function C4() {
  return (
    <div className={classes.gridC4}>
      <IconMessageCircle size={24} stroke={1.5} />
    </div>
  );
} 